var _excluded = ["scrollTo", "typography", "to", "href", "title", "onClick", "onMouseEnter", "onMouseLeave", "openInNewTab", "rel", "hasMinWidthFitContent", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import useScrollToAnchor from "../../../hooks/useScrollToAnchor";
import throwError from "../../../utils/throwError";
import { defaultProps } from "./LinkAtm.props";
import { StyledLinkAtm } from "./LinkAtm.styled";
function LinkAtm(_ref) {
  var scrollTo = _ref.scrollTo,
    _ref$typography = _ref.typography,
    typography = _ref$typography === void 0 ? defaultProps.typography : _ref$typography,
    to = _ref.to,
    href = _ref.href,
    title = _ref.title,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    openInNewTab = _ref.openInNewTab,
    rel = _ref.rel,
    hasMinWidthFitContent = _ref.hasMinWidthFitContent,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var scrollToAnchor = useScrollToAnchor(scrollTo);
  if (!to && !href && !scrollTo && !onClick) {
    throwError('"LinkAtm" has to have defined "to", "href" or "scrollTo" or "onClick" prop!');
  }
  var handleClick = function handleClick(event) {
    if (scrollTo) {
      event.preventDefault();
      scrollToAnchor();
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(StyledLinkAtm, _extends({
    to: to,
    href: scrollTo ? "#".concat(scrollTo.replace("#", "")) : href,
    title: title,
    rel: rel,
    onClick: handleClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    openInNewTab: openInNewTab,
    $typography: typography,
    $onColor: onColor,
    $hasMinWidthFitContent: hasMinWidthFitContent
  }, restProps), children);
}
export default LinkAtm;